import { useEffect, useState } from 'react';

import fetch from 'unfetch';
import { BASE_URL } from '../../globals';

/**
 *
 * @param {*} newBio
 * @returns
 */
const updatebio = async (newBio) => {
	const url = `${BASE_URL}/api/profile/updatebio`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
			authorization: `${localStorage.getItem('auth')}`,
		},
		body: JSON.stringify({
			newBio: newBio,
		}),
	});

	if (res.ok) {
		return { status: 'success' };
	} else {
		return { status: 'error' };
	}
};
export default updatebio;
